import {
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  TextFieldProps,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  InstructionButton,
  InstructionDialog,
} from '~/components/Instructions';
import {
  InstructionDialogConfig,
  useInstructionDialog,
} from '~/components/Instructions/useInstructionDialog';

import { useSxStyles } from './useStyles';

export type VacationBalanceSummaryProps = {
  title?: string;
  balance: number;
  inProgress: number;
  approved: number;
  remaining: number;
  editMode: boolean;
  balanceFieldProps?: TextFieldProps;
  instruction?: InstructionDialogConfig;
};

export const VacationBalanceSummary = (props: VacationBalanceSummaryProps) => {
  const {
    title,
    balance,
    inProgress,
    remaining,
    approved,
    editMode,
    balanceFieldProps,
    instruction,
  } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    isEnabled,
    dialogState: { open },
    dialogProps,
  } = useInstructionDialog(instruction);

  return (
    <Paper variant={'outlined'} sx={sxStyles.paper}>
      <Table size={'small'} sx={sxStyles.table}>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>
              {title}{' '}
              {isEnabled && (
                <InstructionButton
                  size={'small'}
                  onClick={open}
                  sx={sxStyles.instructionButton}
                />
              )}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{t('laBalance')}</TableCell>
            {editMode && !!balanceFieldProps ? (
              <TableCell sx={sxStyles.editCell}>
                <TextField
                  {...balanceFieldProps}
                  margin={'none'}
                  size={'small'}
                  sx={sxStyles.field}
                  fullWidth={true}
                />
              </TableCell>
            ) : (
              <TableCell align={'right'} sx={sxStyles.readCell}>
                {balance}
              </TableCell>
            )}
          </TableRow>
          <TableRow>
            <TableCell>{t('laApproved')}</TableCell>
            <TableCell align={'right'}>{approved}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t('laInProgress')}</TableCell>
            <TableCell align={'right'}>{inProgress}</TableCell>
          </TableRow>
          <Divider component={TableRow} />
          <TableRow>
            <TableCell>{t('laRemaining')}</TableCell>
            <TableCell align={'right'}>{remaining}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      {isEnabled && <InstructionDialog {...dialogProps} />}
    </Paper>
  );
};
